import { Component } from "react";
import PropTypes from "prop-types";
import { defineMessages, injectIntl } from "react-intl";
import constants from "../../utils/constants";

export const msgs = defineMessages({
  cookies: {
    id: "default.cookies.message",
    description: "Cookies Law",
    defaultMessage: "cookies are bad",
  },
  dismiss: {
    id: "default.cookies.dismiss",
    description: "Cookies Law",
    defaultMessage: "cookies dismiss",
  },
  link: {
    id: "default.cookies.link",
    description: "Cookies Law",
    defaultMessage: "cookies link",
  },
});

class CookieConsent extends Component {
  constructor(props) {
    super(props);
    const {
      intl: { formatMessage },
      channel,
      hide,
    } = props;
    const initialize = () =>
      window.cookieconsent.initialise({
        palette: {
          popup: {
            background: "#222222",
          },
          button: {
            background: "#329911",
          },
        },
        theme: "classic",
        content: {
          message: formatMessage(msgs.cookies),
          dismiss: formatMessage(msgs.dismiss),
          link: formatMessage(msgs.link),
          href: "https://www.google.com/policies/technologies/cookies/",
        },
      });

    /* TODO: what happens if the link is share through an email ? => referrer != null */
    if (!hide) {
      if (
        !document.referrer ||
        channel === constants.CHANNEL.GOOGLE ||
        channel === constants.CHANNEL.TRIPADVISOR
      ) {
        if (window.cookieconsent) {
          initialize();
        } else {
          setTimeout(initialize, 4000); // backup in case script loads too late
        }
      }
    }
  }

  render() {
    return null;
  }
}

CookieConsent.propTypes = {
  channel: PropTypes.string,
  hide: PropTypes.bool,
};

export default injectIntl(CookieConsent);
